<template>
  <div id="coinplan">
    <mt-header fixed :title="$t('币计划')">
      <mt-button
        icon="back"
        slot="left"
        onclick="window.history.go(-1)"
      ></mt-button>
    </mt-header>
    <div class="content">
      <div class="caozuo">
        <div
          class="huaru"
          v-bind:class="{ active: isActive }"
          @click="showHuoqi()"
        >
          <span>{{ $t("币计划活期") }}</span>
        </div>
        <div
          class="huachu"
          v-bind:class="{ active: !isActive }"
          @click="showDingqi()"
        >
          <span>{{ $t("币计划定期") }}</span>
        </div>
      </div>
      <ul class="content_detail" v-show="show_huoqi">
        <li v-for="val in pos" @click="plandetail(val.name, val.id)">
          <img v-bind:src="val.coin_icon" class="oImg" />
          <span class="currency_name">{{ val.name }}</span>
          <div class="amount_of wx_rt">
            <p class="count wx_fontSize3">{{ val.annualized_returns }}</p>
          </div>
          <div class="clear"></div>
          <span class="left_lable" v-for="val in val.flag">{{ val }}</span>
          <span class="right_lable">{{ $t("预期年化收益") }}</span>
        </li>
      </ul>
      <ul class="content_detail" v-show="show_dingqi">
        <li v-for="val in dpos" @click="plandetail(val.name, val.id)">
          <img v-bind:src="val.coin_icon" class="oImg" />
          <span class="currency_name">{{ val.name }}</span>
          <div class="amount_of wx_rt">
            <p class="count wx_fontSize3">{{ val.annualized_returns }}</p>
          </div>
          <div class="clear"></div>
          <span class="left_lable" v-for="val in val.flag">{{ val }}</span>
          <span class="right_lable">{{ $t("预期年化收益") }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem, TabItem } from "mint-ui";
import { httpGetLists } from "@/api/wealth";

export default {
  data: function () {
    return {
      pos: [],
      dpos: [],
      selected: 1,
      show_huoqi: true,
      show_dingqi: false,
      isActive: true,
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    getLists: function () {
      // 根据类型获取产品列表
      httpGetLists({ type: 2 })
        .then((res) => {
          this.pos = res.data.list;
        })
        .catch(() => {});

      httpGetLists({ type: 3 })
        .then((res) => {
          this.dpos = res.data.list;
        })
        .catch(() => {});
    },
    showHuoqi() {
      this.isActive = true;
      this.show_huoqi = true;
      this.show_dingqi = false;
    },
    showDingqi() {
      this.isActive = false;
      this.show_huoqi = false;
      this.show_dingqi = true;
    },
    plandetail(title, id) {
      this.$router.push({
        path: "/plandetail",
        query: { title: title, id: id },
      });
    },
    InviteFriends() {
      this.$router.push("/share");
    },
    against() {
      this.$router.push("/against");
    },
    addressBook() {
      this.$router.push("/addressBook");
    },
  },
};
</script>
<style lang="less" scoped>
#coinplan {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  background: #f6f6f6;
}

/*顶部*/
.header {
  width: 100%;
  height: 200px;
  position: relative;
}

.mint-header {
  background: #ffffff;
  color: #212529;
}

.header .bg {
  width: 100%;
  height: 100%;
}

.top {
  width: 100%;
  height: 48px;
  position: absolute;
  top: 0;
}

.file {
  width: 20px;
  height: 20px;
  margin-left: 15px;
}

.cata {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.title {
  width: calc(100% - 114px);
  height: 28px;
  border: 1px solid #fff;
  border-radius: 5px;
  position: absolute;
  left: 57px;
}

.title li {
  width: 50%;
  height: 100%;
  float: left;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 28px;
}

.title .is_active {
  background: #fff;
  color: #0191f5;
}

.asset {
  color: #fff;
  padding: 0 15px;
  position: absolute;
  top: 70px;
}

.amount {
  position: absolute;
  top: 100px;
  color: #fff;
  padding: 0 15px;
}

.add {
  width: 34px;
  height: 34px;
  position: absolute;
  right: 15px;
  top: 90px;
}

.message {
  background: #fff;
  border-radius: 5px;
  position: absolute;
  top: 160px;
  width: calc(100% - 30px);
  left: 15px;
}

.Mes_title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #212529;
  position: relative;
  margin-left: 35px;
}

.Mes_title img {
  position: absolute;
  left: -23px;
  top: 15px;
  width: 15px;
  height: 13px;
}

.Mes_main {
  color: #8c92a8;
  padding: 0 12px;
  line-height: 16.5px;
}

.titme {
  width: 100%;
  padding: 0 12px;
  height: 40px;
  position: relative;
  line-height: 40px;
  color: #8c92a8;
}

.titme .detail {
  position: absolute;
  right: 30px;
  color: #0191f5;
}

/*内容*/
.content {
  background: #f6f6f6;
  width: 100%;
  margin: 40px 0 0 0;
}

.local {
  padding-top: 0;
}

.content_detail {
  padding: 0 15px 0 15px;
}

.content_detail li {
  width: 100%;
  background: #fff;
  margin-top: 12px;
  height: 98px;
}

.oImg {
  width: 34px;
  height: 34px;
  margin: 15px 10px 5px 14px;
}

.currency_name {
  position: relative;
  top: -20px;
  font-size: 14px;
  font-weight: bold;
}

.amount_of {
  width: 25%;
  text-align: center;
}

.count {
  color: #0191f5;
  padding: 22px 0 10px 0;
  font-weight: bold;
}

.money {
  color: #8c92a8;
}

/*分享*/
.share {
  width: 150px;
  position: absolute;
  background: #fff;
  top: 68px;
  right: 15px;
  border-radius: 6px;
  box-shadow: 0 0 20px rgba(5, 61, 109, 0.2);
}

.share li {
  margin: 0 15px;
  height: 51px;
  border-bottom: 1px solid #e3e8ed;
  line-height: 51px;
}

.mark {
  width: 20px;
  height: 20px;
  margin: 0 16px 0 5px;
}

.main {
  color: #212529;
  position: relative;
  top: -4px;
}

.triangle {
  position: relative;
  top: -8px;
  left: 80%;
}

.triangle_border_up {
  width: 0;
  height: 0;
  border-width: 0 8px 8px;
  border-style: solid;
  border-color: transparent transparent #fff; /*透明 透明  灰*/
  position: relative;
}

.mywealth {
  font-size: 12px;
  margin-right: 15px;
  color: #fff;
}

.shandui {
  width: 55px;
  height: 25px;
  margin-left: 15px;
}

.page-swipe img {
  width: 100%;
  height: 200px;
}

.page-swipe .mint-swipe-item {
}

.page-swipe .slide1 {
  background-color: #0089dc;
  color: #fff;
}

.page-swipe .slide2 {
  background-color: #ffd705;
  color: #000;
}

.page-swipe .slide3 {
  background-color: #ff2d4b;
  color: #fff;
}

.page-swipe-desc {
  text-align: center;
  color: #666;
}

.footer {
  width: 100%;
  height: 75px;
  position: relative;
}

.footer .item {
  width: 50%;
  height: 100%;
  font-size: 16px;
  color: #212529;
  text-align: center;
  background: #fff;
  position: absolute;
  top: 0;
}

.footer .item .detail {
  height: 38px;
  position: absolute;
  top: 19px;
  width: 100px;
  left: 50%;
  margin: 0 0 0 -50px;
}

.footer .item span {
  line-height: 38px;
  display: inline-block;
  position: absolute;
  width: 80px;
  left: 50px;
  text-align: left;
}

.footer .item.right {
  right: 0;
}

.footer .item img {
  width: 38px;
  display: block;
  position: absolute;
}

.remen {
  font-size: 16px;
  margin: 18px 0;
  color: #212529;
  font-weight: bold;
}

.left_lable {
  font-size: 12px;
  padding: 5px 8px;
  background-color: #f6f6f6;
  margin: 0 10px;
  float: left;
  border-radius: 4px;
  color: #8c92a8;
}

.right_lable {
  font-size: 12px;
  padding: 5px 8px;
  margin: 0 10px;
  float: right;
  border-radius: 4px;
  color: #8c92a8;
}

.clear {
  clear: both;
}

.line {
  width: 0;
  height: 40px;
  border-right: 1px solid #e3e8ed;
  position: absolute;
  left: 50%;
  z-index: 1;
  top: 16px;
}

.caozuo {
  width: 100%;
  height: 40px;
  color: #8c92a8;
  position: relative;
  text-align: center;
  background-color: #fff;

  .active {
    color: #1296db;

    span {
      line-height: 36px;
      display: inline-block;
      border-bottom: 2px solid #1296db;
    }
  }

  .huachu {
    height: 100%;
    width: 50%;
    line-height: 40px;
    font-size: 14px;
    position: absolute;
    right: 0;
  }

  .huaru {
    height: 100%;
    width: 50%;
    line-height: 40px;
    font-size: 14px;
    position: absolute;
    left: 0;
  }
}
</style>
